import React from "react";

import { useTranslation } from "react-i18next";

import { HalfTotals } from "@data-types/sport-stats/SportStatsTypes";
import RecentGames from "../RecentGames";

import Graph from "../Graph";

export default function OverUnderByPeriod(props: {
	homeTeam: HalfTotals;
	awayTeam: HalfTotals;
}) {
	const { t } = useTranslation();

	return (
		<>
			<RecentGames
				homeTeamEventCount={props.homeTeam?.eventCount}
				awayTeamEventCount={props.awayTeam?.eventCount}
			/>

			<Graph
				title={
					t("EVENT.STATISTICS.BETTING_TYPE_STATS.COMBINED_AV_GOALS") +
					` (${props.homeTeam?.combinedAverageGoals})`
				}
				home={t("EVENT.OFFER.COMPETITOR_HOME")}
				away={t("EVENT.OFFER.COMPETITOR_AWAY")}
				graphName={t("EVENT.STATISTICS.GOALS")}
				data={{
					homeValue: props.homeTeam?.avgGoalsScored,
					awayValue: props.awayTeam?.avgGoalsScored,
				}}
				isTotalGraph
			/>

			<Graph
				title={t(
					"EVENT.STATISTICS.BETTING_TYPE_STATS.AV_GOALS_IN_FIRST_HALF"
				)}
				graphName={t("EVENT.STATISTICS.GOALS")}
				data={{
					homeValue: props.homeTeam?.averageGoalsScoredFirstHalf,
					awayValue: props.awayTeam?.averageGoalsScoredFirstHalf,
				}}
				maxHome={props.homeTeam?.avgGoalsScored}
				maxAway={props.awayTeam?.avgGoalsScored}
			/>

			<Graph
				title={t(
					"EVENT.STATISTICS.BETTING_TYPE_STATS.AV_GOALS_IN_SECOND_HALF"
				)}
				data={{
					homeValue: props.homeTeam?.averageGoalsScoredSecondHalf,
					awayValue: props.awayTeam?.averageGoalsScoredSecondHalf,
				}}
				graphName={t("EVENT.STATISTICS.GOALS")}
				maxHome={props.homeTeam?.avgGoalsScored}
				maxAway={props.awayTeam?.avgGoalsScored}
			/>
		</>
	);
}
